import { ExportFile, UserSelect } from '@organization/components'
import { RangePickerFilter } from '@shared/components'
import { useQueryUpdate, useSessionContext } from '@shared/hooks'
import { getFileName } from '@shared/utils'
import { Flex, Select, Space } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

const eventTypes = [
  'otp_sent_success',
  'otp_sent_fail',
  'otp_verify_success',
  'otp_verify_fail',
  'backup_code_verify_success',
  'backup_code_verify_fail',
  'trusted_device_created',
  'account_locked'
]

export const LogMFAFilters = () => {
  const { t } = useTranslation()
  const { params, updateQuery } = useQueryUpdate()
  const { user, isAdmin } = useSessionContext()

  return (
    <Flex justify="space-between">
      <Space wrap>
        {isAdmin && (
          <UserSelect
            value={params.user}
            onChange={(user: string) => updateQuery({ user })}
          />
        )}

        <RangePickerFilter
          maxDate={dayjs()}
          fromParam="createdAtFrom"
          toParam="createdAtTo"
        />

        <Select
          placeholder={t('table.type')}
          value={params.eventType}
          onChange={(eventType) => updateQuery({ eventType })}
          options={eventTypes.map((value) => ({
            label: t(`log_mfa_type.${value}`),
            value
          }))}
          style={{ minWidth: 200 }}
          allowClear
        />
      </Space>

      <ExportFile
        url="/mfa/audit-logs/export/"
        name={getFileName('mfa_audit_logs', 'csv')}
        buttonName={t('button.export')}
        iconPosition="end"
        type="primary"
        exportType="csv"
        notifyEmail={user?.user?.email}
      />
    </Flex>
  )
}
